@if (!newSelectPatron.data) {
  <div fxLayout="column" fxLayoutAlign="center center">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
}

@if (newSelectPatron.data) {
  <div fxLayout="column" fxLayoutAlign="start center" class="width-100 ag-px-sm">
    <div fxFlex>
      @if (hold) {
        <h5>
          {{ hold ? 'Select a Patron' : 'SHAREit Lookup' }}
        </h5>
      }
    </div>
    <div fxLayout="column" fxFlex>
      <form class="font-0-9" (ngSubmit)="searchPatrons()" fxLayoutGap="10px">
        <div fxLayout="column">
          <div fxLayout="column" fxFlex>
            @if (isInSideNav) {
              <label for="searchTerm" class="ag-mr-sm">Search Patron</label>
            }
            <mat-form-field appearance="outline" [ngClass]="{ inSideNav: isInSideNav }" fxFlex>
              @if (!isInSideNav) {
                <mat-label>Search Patron</mat-label>
              }
              <input
                matInput
                type="text"
                id="searchTerm"
                placeholder="Search Patron"
                [disabled]="!canReserve"
                [(ngModel)]="searchTerm"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div fxLayout="column" fxFlex="50">
              @if (isInSideNav) {
                <label for="selectSearchIndex" class="ag-mr-sm"> Select Search Index </label>
              }
              <mat-form-field appearance="outline" [ngClass]="{ inSideNav: isInSideNav }" fxFlex>
                @if (!isInSideNav) {
                  <mat-label>Select Search Index</mat-label>
                }
                <mat-select
                  id="selectSearchIndex"
                  [(ngModel)]="searchIndex"
                  [disabled]="!canReserve"
                  [ngModelOptions]="{ standalone: true }"
                >
                  @for (patronIn of newSelectPatron?.data.patronIndicesList; track patronIn) {
                    <mat-option [value]="patronIn.code">
                      {{ patronIn.displayName }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div fxLayout="column" fxFlex="50">
              @if (isInSideNav) {
                <label for="chooseUserGroup" class="ag-mr-sm"> Choose User Group </label>
              }
              <mat-form-field appearance="outline" [ngClass]="{ inSideNav: isInSideNav }" fxFlex>
                @if (!isInSideNav) {
                  <mat-label>Choose User Group</mat-label>
                }
                <mat-select
                  id="chooseUserGroup"
                  [(ngModel)]="patronGroupId"
                  [disabled]="!canReserve"
                  [ngModelOptions]="{ standalone: true }"
                >
                  @for (
                    patron of newSelectPatron.data.patronGroupsList;
                    track patron;
                    let i = $index
                  ) {
                    <mat-option [value]="patron.groupID" [attr.selected]="i === 0 ? true : null">
                      {{ patron.groupName }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-around center">
            <button
              mat-raised-button
              type="submit"
              class="ag-mat-button-primary"
              [disabled]="searching || !canReserve"
            >
              @if (searching) {
                <mat-icon>
                  <mat-spinner diameter="18"></mat-spinner>
                </mat-icon>
              }
              Search
            </button>
            @if (showCurrentPatron) {
              <button
                mat-raised-button
                class="ag-mat-button-primary"
                type="button"
                (click)="currentPatron()"
              >
                Current Patron
              </button>
            }
          </div>
          @if (searchPatronResults) {
            <div class="text-center ag-py-sm">
              <a
                tabindex="0"
                (agInteract)="getPrevPatrons()"
                [ngClass]="!hasPrevious ? 'disable-link' : 'pointer'"
              >
                <i class="fa fa-angle-left" aria-hidden="true"></i> Previous
              </a>
              <a
                tabindex="0"
                (agInteract)="getNextPatrons()"
                [ngClass]="!hasNext ? 'disable-link' : 'pointer'"
              >
                Next <i class="fa fa-angle-right" aria-hidden="true"> </i>
              </a>
            </div>
          }
        </div>
      </form>
    </div>
    @if (searchPatronResults) {
      <div fxLayout="row" fxLayoutGap="10px" class="patron-listings card">
        @if (searchPatronResults.patrons?.length) {
          <div fxLayout="column" fxLayoutGap="10px" class="width-100">
            <!-- Header Row -->
            <div class="ag-mb-sm" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
              <div fxFlex="30" fxLayoutGap="10px"><strong>Barcode</strong></div>
              <div fxFlex="20" fxLayoutGap="10px"><strong>Last Name</strong></div>
              <div fxFlex="20" fxLayoutGap="10px"><strong>First Name</strong></div>
              <div fxFlex="30" fxLayoutGap="10px"><strong>Address</strong></div>
            </div>
            <!-- Patron Rows -->
            @for (patron of searchPatronResults.patrons; track patron) {
              <div
                class="ag-mb-sm pointer"
                fxLayout="row"
                fxLayoutGap="10px"
                fxLayoutAlign="start center"
                (agInteract)="choosePatron(patron)"
              >
                <div fxFlex="30" fxLayoutGap="10px">{{ patron.barcode }}</div>
                <div fxFlex="20" fxLayoutGap="10px" class="truncate-ellipsis">
                  {{ patron.lastName }}
                </div>
                <div fxFlex="20" fxLayoutGap="10px" class="truncate-ellipsis">
                  {{ patron.firstName }}
                </div>
                <div fxFlex="30" fxLayoutGap="10px" class="truncate-ellipsis">
                  {{ patron.address }}
                </div>
              </div>
            }
          </div>
        } @else {
          <div fxLayoutAlign="center center">No patrons available</div>
        }
        <!-- No Results Template -->
      </div>
    }
    @if (searchPatronResults) {
      <div fxLayoutAlign="center center" class="text-center ag-py-sm">
        <a
          tabindex="0"
          (agInteract)="getPrevPatrons()"
          [ngClass]="!hasPrevious ? 'disable-link' : 'pointer'"
        >
          <i class="fa fa-angle-left" aria-hidden="true"></i> Previous
        </a>
        <a
          tabindex="0"
          (agInteract)="getNextPatrons()"
          [ngClass]="!hasNext ? 'disable-link' : 'pointer'"
        >
          Next <i class="fa fa-angle-right" aria-hidden="true"> </i>
        </a>
      </div>
    }
  </div>
}
